import { createContext, useContext, type PropsWithChildren } from "react";

import { type LayoutSettings } from "src/staticData";

interface LayoutSettingsContextProviderProps extends PropsWithChildren {
  layoutSettings: LayoutSettings;
}

const LayoutSettingsContext = createContext<LayoutSettings | null>(null);

export function LayoutSettingsContextProvider(
  props: LayoutSettingsContextProviderProps,
) {
  return (
    <LayoutSettingsContext.Provider value={props.layoutSettings}>
      {props.children}
    </LayoutSettingsContext.Provider>
  );
}

export function useLayoutSettingsContext(): LayoutSettings {
  const context = useContext(LayoutSettingsContext);

  if (!context) {
    throw new Error(
      "useLayoutSettingsContext must be used within LayoutSettingsContextProvider",
    );
  }

  return context;
}
